var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-container"},[_c('transition',{attrs:{"name":"slide","mode":"out-in"}},[_c('p',{key:_vm.text.id,staticClass:"notification-text"},[_c('span',[_vm._v(_vm._s(_vm.text.val))])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }